module.exports = __webpack_public_path__ + "static/media/business-561387_1920.1f47edb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/business-561387_1920.jpg
// module id = 890
// module chunks = 0